export const enum eventConstants {
  createEventRequest = "CREATE_EVENT_REQUEST",
  createEventSuccess = "CREATE_EVENT_SUCCESS",
  createEventFailure = "CREATE_EVENT_FAILURE",
  clearCreateEventState = "CLEAR_CREATE_EVENT_STATE",

  listEventsRequest = "LIST_EVENTS_REQUEST",
  listEventsSuccess = "LIST_EVENTS_SUCCESS",
  listEventsFailure = "LIST_EVENTS_FAILURE",
  
  assignMemberToEventsRequest = "ASSIGN_MEMBER_TO_EVENTS_REQUEST",
  assignMemberToEventsSuccess = "ASSIGN_MEMBER_TO_EVENTS_SUCCESS",
  assignMemberToEventsFailure = "ASSIGN_MEMBER_TO_EVENTS_FAILURE",

  viewEventsRequest = "VIEW_EVENTS_REQUEST",
  viewEventsSuccess = "VIEW_EVENTS_SUCCESS",
  viewEventsFailure = "VIEW_EVENTS_FAILURE",

  updateEventsRequest = "UPDATE_EVENTS_REQUEST",
  updateEventsSuccess = "UPDATE_EVENTS_SUCCESS",
  updateEventsFailure = "UPDATE_EVENTS_FAILURE",
  updateEventsRequiresConfirmation = "UPDATE_EVENTS_REQUIRES_CONFIRMATION",
  clearUpdateEventState = "CLEAR_UPDATE_EVENT_STATE",
  clearUpdateEventConfirmation = "CLEAR_UPDATE_EVENT_CONFIRMATION",

  closeEventRequest = "CLOSE_EVENT_REQUEST",
  closeEventSuccess = "CLOSE_EVENT_SUCCESS",
  closeEventFailure = "CLOSE_EVENT_FAILURE",
  clearCloseEventState = "CLEAR_CLOSE_EVENT_STATE",

  getEventsWithEnquiriesRequest = "GET_EVENTS_WITH_ENQUIRIES_REQUEST",
  getEventsWithEnquiriesSuccess = "GET_EVENTS_WITH_ENQUIRIES_SUCCESS",
  getEventsWithEnquiriesFailure = "GET_EVENTS_WITH_ENQUIRIES_FAILURE",

  updateEventStageRequest = "UPDATE_EVENT_STAGE_REQUEST",
  updateEventStageSuccess = "UPDATE_EVENT_STAGE_SUCCESS",
  updateEventStageFailure = "UPDATE_EVENT_STAGE_FAILURE",
  clearUpdateEventStageState = "CLEAR_UPDATE_EVENT_STAGE_STATE",

}
